module.exports = __webpack_public_path__ + "resources/img/img-manufacturing-fems-jp.e20a6fdc48295a7da1c28248184b7845.png";